var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AboutDialog',{attrs:{"title":_vm.platformStr,"showBonusScene":_vm.showBonusScene,"selfLogo":false},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"container_box"},[_c('div',{staticClass:"content"},[_c('CarouselInfo',{attrs:{"fixed":""},on:{"onChange":_vm.onChange,"click":_vm.click}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54eea830","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./yotta-vue-components/vision/About.vue
// module id = null
// module chunks = 